import { TemplateModel } from "./template.model";

export interface ProjectModel {
    projectId?: number;
    projectNumber: string;
    projectName: string;
    commProject: string;
    warrantyProject: string;
    projectManager?: string;
    engineer?: string;
    projectCoordinator?: string;
    businessUnitId?: number;
    projectType?: number;
    projectStatusId?: number;
    inverterModelId?: number;
    userCount?: number;
    userRoleName?: string;
    customerName: string;
    endUserName?: string;
    siteContact?: string;
    customerContactNumber?: string;
    customerEmailAddress?: string;
    customerAddress1?: string;
    customerAddress2?: string;
    customerCity?: string;
    customerState?: string;
    customerZip?: string;
    countryId?: number | null;
    countryName?: string | null;
    countryIso2Code?: string | null;
    notes?: string;
    managerNotes?: string;
    transformerId?: number;
    transformerName?: string;
    integratorId?: number;
    integratorName?: string;
    startDate?: Date;
    deliveryDate?: Date;
    cxStartDate?: Date;
    skidConfiguration?: string;
    skids?: number;
    n1?: number;
    n2?: number;
    n3?: number;
    n4?: number;
    n5?: number;
    n6?: number;
    n7?: number;
    auxPackage?: string;
    oilContainment?: string;
    auxiliaryRackLight?: number;
    numberGfci?: number;
    backfeedDate?: Date;
    incoTermsId?: number;
    freightBroker?: string;
    isActive?: boolean;
    isUserProjectActive?: boolean;
    isFavourite?: boolean;
    projectStatusIndicator?: 'Green' | 'Yellow' | 'None' | string | null;
    lastDailyReportDate?: string | null;
    createdAt?: Date;
    updatedAt?: Date;
    status?: number;
    createdBy?: number;
    prefix?: string;
    latitude?: string;
    longitude?: string;
    backupFolderPath?: string;
    siteManager?: number;
    fieldLead?: number;
    warrantyInverterStartDate?: string;
    warrantyInverterEndDate?: string;
    warrantyTransformerStartDate?: string;
    warrantyTransformerEndDate?: string;
    warrantySkidStartDate?: string;
    warrantySkidEndDate?: string;
    contractPo?: string;
    inverterTestReportPath?: string;
    inverterTestReportDestination?: number;
    transformerTestReportPath?: string;
    transformerTestReportDestination?: number;
    isPwaSite?: boolean;
}

export interface UpdateProjectSettingsRequest {
    siteManager: number | null;
    fieldLead: number | null;
    siteContact: string | null;
    customerContactNumber: string | null;
    customerEmailAddress: string | null;
    managerNotes: string | null;
    warrantyInverterStartDate: string | null;
    warrantyInverterEndDate: string | null;
    warrantyTransformerStartDate: string | null;
    warrantyTransformerEndDate: string | null;
    warrantySkidStartDate: string | null;
    warrantySkidEndDate: string | null;
    contractPo: string | null;
    inverterTestReportPath: string | null;
    inverterTestReportDestination: number | null;
    transformerTestReportPath: string | null;
    transformerTestReportDestination: number | null;
    backupFolderPath: string | null;
    isPwaSite: boolean;
}

export interface ProjectLocationModel {
    projectId: number;
    projectName?: string;
    projectNumber?: string;
    customerName?: string;
    customerAddress1?: string;
    customerCity?: string;
    customerState?: string;
    customerZip?: string;
    countryId?: number | null;
    countryName?: string | null;
    countryIso2Code?: string | null;
    latitude?: string;
    longitude?: string;
    users?: string[];
}

export interface AssignProjectTemplatesRequest {
    projectId: number;
    templateIds: number[];
}

export interface AssignTemplatesToSkidsRequest {
    projectId: number;
    templateIds: number[];
    blockScheduleIds: number[];
}

export interface ProjectTemplateSkidAssignmentModel {
    blockScheduleId: number;
    projectTemplateId: number;
    status?: string | null;
    isOverride?: boolean;
    date?: string | Date | null;
    dueDate?: string | Date | null;
    hasChecklistResponses: boolean;
}

export interface CountryModel {
    countryId: number;
    countryName: string;
    iso2Code: string;
    isActive: boolean;
}

export interface CloneProjectTemplateRequest {
    sourceProjectTemplateId: number;
    templateName: string;
    updatedBy?: number;
}

export interface ProjectResponse {
    project: ProjectModel;
    message?: string;
}

export interface ProjectTemplateModel extends TemplateModel {
    projectId: number;
    masterTemplateId?: number;
    status?: number;
    sortOrder?: number;
    dueDate?: Date;
    statusUpdatedAt?: Date;
    statusUpdatedBy?: number;
}

export enum ProjectTemplateStatus {
    Draft = 0,
    Submitted = 1,
    Verified = 2
}

export interface SaveSkidChecklistRequest {
    blockScheduleId: number;
    projectId: number;
    responses: ChecklistResponseItem[];
}

export interface ChecklistResponseItem {
    templateId: number;
    lineItemId: number;
    value: any;
}

export interface SaveSkidChecklistResponse {
    success: boolean;
    message?: string;
    recordsSaved: number;
    responseIdMap?: { [lineItemId: number]: number };
}

export interface SkidChecklistResponseModel {
    id: number;
    blockScheduleId: number;
    projectId: number;
    templateId: number;
    lineitemId: number;
    responseValue?: string;
    createdBy?: number;
    createdAt?: string;
    updatedBy?: number;
    updatedAt?: string;
}

export interface BlockScheduleFileModel {
    id: number;
    blockScheduleId: number;
    skidChecklistResponseId: number;
    fileName?: string;
    fileFullName?: string;
    filePath?: string;
    thumbnailPath?: string;
    fileType?: string;
    fileSize?: number;
    contentType?: string;
    createdBy?: number;
    createdDate?: string;
    // For displaying images
    thumbnailUrl?: string;  // Blob URL for thumbnail
    imageUrl?: string;       // Blob URL for full image
}

export interface UploadFileResponse {
    success: boolean;
    message?: string;
    filesUploaded: number;
    fileIds: number[];
}
